// extracted by mini-css-extract-plugin
module.exports = {"inputs":"style_inputs__1HVQI","controls":"style_controls__2VVy4","actions":"style_actions__3LE5x"};